const config = require('../config/config');
const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const api = FuzzyReaction.Utils.ApiService;
const ActionTypes = FuzzyReaction.Constants.ActionTypes;
const AppDispatcher = FuzzyReaction.Dispatcher;

module.exports = {
    baseUrl: config.base.apiVersionedUrl + 'email-messages/',

    sendTest: function (messageId, recipientEmail) {
        api.post(this.baseUrl + messageId + '/send-test', recipientEmail, {}, function () {
            AppDispatcher.dispatch({
                type: ActionTypes.alerts.ALERT_SUCCESS,
                message: 'The test email was sent.',
                actionOrError: 'Success!'
            });
        });
    }
};
